function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "classnames", "ramda", "react", "react-jss", "@braindate/util/lib/react/hoc/withForwardRef", "../icon/SpinnerIcon", "./BaseButton.style"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("classnames"), require("ramda"), require("react"), require("react-jss"), require("@braindate/util/lib/react/hoc/withForwardRef"), require("../icon/SpinnerIcon"), require("./BaseButton.style"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classnames, global.ramda, global.react, global.reactJss, global.withForwardRef, global.SpinnerIcon, global.BaseButton);
    global.BaseButton = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _classnames, _ramda, React, _reactJss, _withForwardRef, _SpinnerIcon, _BaseButton) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _classnames = _interopRequireDefault(_classnames);
  React = _interopRequireWildcard(React);
  _withForwardRef = _interopRequireDefault(_withForwardRef);
  _SpinnerIcon = _interopRequireDefault(_SpinnerIcon);
  _BaseButton = _interopRequireDefault(_BaseButton);
  var _excluded = ["className", "style", "isDisabled", "isSubmitting", "isFetching", "large", "fitText", "children", "withSuccess", "type", "onClick", "hasFocus", "autoFocus", "id", "forwardedRef", "withEvenSides", "aria-label", "aria-expanded", "aria-controls", "aria-pressed", "data-testid"];
  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
  var useStyles = (0, _reactJss.createUseStyles)(_BaseButton.default);
  var BaseButton = function BaseButton(_ref) {
    var _classNames;
    var className = _ref.className,
      style = _ref.style,
      isDisabled = _ref.isDisabled,
      isSubmitting = _ref.isSubmitting,
      isFetching = _ref.isFetching,
      large = _ref.large,
      fitText = _ref.fitText,
      children = _ref.children,
      withSuccess = _ref.withSuccess,
      type = _ref.type,
      onClick = _ref.onClick,
      hasFocus = _ref.hasFocus,
      autoFocus = _ref.autoFocus,
      id = _ref.id,
      forwardedRef = _ref.forwardedRef,
      withEvenSides = _ref.withEvenSides,
      ariaLabel = _ref["aria-label"],
      ariaExpanded = _ref["aria-expanded"],
      ariaControls = _ref["aria-controls"],
      ariaPressed = _ref["aria-pressed"],
      dataTestid = _ref["data-testid"],
      props = _objectWithoutProperties(_ref, _excluded);
    /*
     |----------------------------------------------------------------------------
     | Refs
     |----------------------------------------------------------------------------
     */

    var rootRef = forwardedRef ? forwardedRef : /*#__PURE__*/React.createRef();

    /*
     |----------------------------------------------------------------------------
     | Effects
     |----------------------------------------------------------------------------
     */

    React.useEffect(function () {
      var rootElt = rootRef.current;

      // Get the button reference and focus on it. The setTimeout is needed
      // to make sure the focus action happen after the button is fully loaded.
      // FIXME: Dirty
      if (hasFocus && rootElt) {
        setTimeout(function () {
          return rootElt.focus();
        }, 0);
      }
    }, []);

    /*
     |----------------------------------------------------------------------------
     | Event Handlers
     |----------------------------------------------------------------------------
     */

    /*
     |----------------------------------------------------------------------------
     | Classes
     |----------------------------------------------------------------------------
     */

    var classes = useStyles({
      withEvenSides: withEvenSides
    });
    var rootClasses = (0, _classnames.default)(classes.root, className, (_classNames = {}, _defineProperty(_classNames, classes["root-isSubmitting"], isSubmitting), _defineProperty(_classNames, classes["root-large"], large), _defineProperty(_classNames, classes["root-fitText"], fitText), _defineProperty(_classNames, classes["root-isFetching"], isFetching), _defineProperty(_classNames, classes["root-withSuccess"], !isDisabled && withSuccess), _classNames));
    var spinnerClasses = (0, _classnames.default)(classes.spinner, _defineProperty({}, classes["spinner-isFetching"], isFetching));

    /*
     |----------------------------------------------------------------------------
     | Elements
     |----------------------------------------------------------------------------
     */

    var spinnerElt = isSubmitting || isFetching ? /*#__PURE__*/React.createElement("span", {
      className: spinnerClasses
    }, /*#__PURE__*/React.createElement(_SpinnerIcon.default, {
      small: true
    })) : null;
    return /*#__PURE__*/React.createElement("button", _extends({}, props, {
      className: rootClasses,
      style: style,
      disabled: isDisabled || isFetching,
      type: type,
      onClick: onClick,
      ref: rootRef,
      id: id
      // eslint-disable-next-line jsx-a11y/no-autofocus
      ,
      autoFocus: autoFocus,
      "aria-label": ariaLabel,
      "aria-expanded": ariaExpanded,
      "aria-controls": ariaControls,
      "aria-pressed": ariaPressed,
      "data-testid": dataTestid
    }), spinnerElt, children);
  };
  var _default = (0, _ramda.compose)(React.memo, _withForwardRef.default)(BaseButton);
  _exports.default = _default;
});